<template>
    <div id="app">
        <Main :language="language" />
    </div>
</template>

<script>
import Main from './components/Main'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    data() {
        return {}
    },
    components: {
        Main
    },

    created() {
        window.location.href = 'https://store.habby.com/game/4?page=giftcode';

        // 禁止双指放大
        document.documentElement.addEventListener(
            'touchstart',
            function (event) {
                if (event.touches.length > 1) {
                    event.preventDefault()
                }
            },
            false
        )
        var lastTouchEnd = 0
        document.documentElement.addEventListener(
            'touchend',
            function (event) {
                var now = Date.now()
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault()
                }
                lastTouchEnd = now
            },
            false
        )
        document.addEventListener('gesturestart', function (event) {
            event.preventDefault()
        })

        if (
            (parsed.language && parsed.language === 'en') ||
            parsed.language === 'ko' ||
            parsed.language === 'ja' ||
            parsed.language === 'zh-TW'
        ) {
            this.language = parsed.language
        } else {
            this.language = 'en'
        }
        let that = this
        ;(function (doc, win) {
            var docEl = doc.documentElement,
                resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                recalc = function () {
                    var clientWidth = docEl.clientWidth
                    var clientHeight = docEl.clientHeight

                    if (!clientWidth) return
                    if (clientWidth < 1200) {
                        docEl.style.fontSize = 16 * (clientWidth / 720) + 'px'
                        if (clientWidth > 1023) {
                            docEl.style.fontSize = '18px'
                        }
                    } else {
                        docEl.style.fontSize = '18px'
                    }
                }
            if (!doc.addEventListener) return
            win.addEventListener(resizeEvt, recalc, false)
            doc.addEventListener('DOMContentLoaded', recalc, false)
        })(document, window)
    }
}
</script>

<style lang="less">
html,
body {
    min-height: 100%;
    text-align: center;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
}

a {
    text-decoration: none;
    color: #232323;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
.el-scrollbar {
    .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue